function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import Popup from '../popup';

var ActionSheet =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ActionSheet, _PureComponent);

  function ActionSheet() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ActionSheet);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ActionSheet)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderActions = function (action, index) {
      var prefixCls = _this.props.prefixCls;
      var actionCls = classnames("".concat(prefixCls, "__item"), action.className, _defineProperty({}, "".concat(prefixCls, "__item--").concat(action.theme), !!action.theme));
      return React.createElement("div", {
        key: +index,
        className: actionCls,
        onClick: action.onClick
      }, action.text);
    };

    _this.renderCancel = function () {
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          onCancel = _this$props.onCancel,
          cancelText = _this$props.cancelText,
          locale = _this$props.locale;
      return typeof onCancel === 'function' && React.createElement("div", {
        className: "".concat(prefixCls, "__cancel")
      }, React.createElement("div", {
        className: "".concat(prefixCls, "__item"),
        onClick: onCancel
      }, cancelText || locale.cancelText));
    };

    return _this;
  }

  _createClass(ActionSheet, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          spacing = _this$props2.spacing,
          visible = _this$props2.visible,
          onMaskClick = _this$props2.onMaskClick,
          actions = _this$props2.actions,
          destroy = _this$props2.destroy;
      var cls = classnames(prefixCls, _defineProperty({}, "".concat(prefixCls, "--spacing"), spacing));
      return React.createElement(Popup, {
        className: className,
        visible: visible,
        onMaskClick: onMaskClick,
        destroy: destroy
      }, React.createElement("div", {
        className: cls
      }, React.createElement("div", {
        className: "".concat(prefixCls, "__actions")
      }, actions.map(this.renderActions)), this.renderCancel()));
    }
  }]);

  return ActionSheet;
}(PureComponent);

ActionSheet.defaultProps = {
  prefixCls: 'za-action-sheet',
  visible: false,
  spacing: false,
  actions: [],
  destroy: true
};
export { ActionSheet as default };